import { render, staticRenderFns } from "./select-apportion-period.vue?vue&type=template&id=06b471da&scoped=true&"
import script from "./select-apportion-period.vue?vue&type=script&lang=js&"
export * from "./select-apportion-period.vue?vue&type=script&lang=js&"
import style0 from "./select-apportion-period.vue?vue&type=style&index=0&id=06b471da&prod&lang=scss&scoped=true&"
import style1 from "./select-apportion-period.vue?vue&type=style&index=1&id=06b471da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b471da",
  null
  
)

export default component.exports